var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "basic-container",
    [
      _c(
        "div",
        [
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.tabClick },
              model: {
                value: _vm.activeSource,
                callback: function ($$v) {
                  _vm.activeSource = $$v
                },
                expression: "activeSource",
              },
            },
            [
              _c("el-tab-pane", { attrs: { label: "弹窗", name: 2 } }),
              _c("el-tab-pane", { attrs: { label: "banner", name: 3 } }),
              _c("el-tab-pane", { attrs: { label: "icon", name: 4 } }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "search-contain" },
        [
          _c(
            "el-form",
            {
              ref: "query",
              attrs: { model: _vm.query, inline: true, size: "mini" },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.activeSource === 4 ? "icon名称" : "广告名称",
                  },
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入名称", clearable: "" },
                    model: {
                      value: _vm.query.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.query, "name", $$v)
                      },
                      expression: "query.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "状态", prop: "status" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "请选择",
                        clearable: "",
                        filterable: "",
                      },
                      model: {
                        value: _vm.query.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "status", $$v)
                        },
                        expression: "query.status",
                      },
                    },
                    _vm._l(_vm.statusList, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "活动时间", prop: "daterange" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "220px" },
                    attrs: {
                      format: "yyyy-MM-dd",
                      "value-format": "yyyy-MM-dd",
                      type: "daterange",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                    },
                    model: {
                      value: _vm.daterange,
                      callback: function ($$v) {
                        _vm.daterange = $$v
                      },
                      expression: "daterange",
                    },
                  }),
                ],
                1
              ),
              _vm.activeSource === 3 || _vm.activeSource === 4
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.activeSource === 4 ? "排序" : "权重",
                        prop: "sort",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择", clearable: "" },
                          model: {
                            value: _vm.query.sort,
                            callback: function ($$v) {
                              _vm.$set(_vm.query, "sort", $$v)
                            },
                            expression: "query.sort",
                          },
                        },
                        _vm._l(_vm.sortList, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.value, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.activeSource === 4 ? "位置" : "广告位置",
                    prop: "locationKey",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "请选择",
                        clearable: "",
                        filterable: "",
                      },
                      model: {
                        value: _vm.query.locationKey,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "locationKey", $$v)
                        },
                        expression: "query.locationKey",
                      },
                    },
                    _vm._l(_vm.locationList, function (item) {
                      return _c("el-option", {
                        key: item.advertisingLocationKey,
                        attrs: {
                          label: item.advertisingLocationDesc,
                          value: item.advertisingLocationKey,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "创建人" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入", clearable: "" },
                    model: {
                      value: _vm.query.createUser,
                      callback: function ($$v) {
                        _vm.$set(_vm.query, "createUser", $$v)
                      },
                      expression: "query.createUser",
                    },
                  }),
                ],
                1
              ),
              _vm.activeSource === 3 || _vm.activeSource === 4
                ? _c(
                    "el-form-item",
                    { attrs: { label: "地区" } },
                    [
                      _c("YdCitySelect", {
                        attrs: {
                          mode: "1",
                          placeholder: "请选择地级归属",
                          customHttp: _vm.getDriverAreaTree,
                          fieldFormat: _vm.fieldFormat,
                        },
                        model: {
                          value: _vm.query.locationId,
                          callback: function ($$v) {
                            _vm.$set(_vm.query, "locationId", $$v)
                          },
                          expression: "query.locationId",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        icon: "el-icon-search",
                        loading: _vm.loading,
                      },
                      on: { click: _vm.searchChange },
                    },
                    [_vm._v("筛选")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "danger",
                        icon: "el-icon-delete",
                        loading: _vm.loading,
                      },
                      on: { click: _vm.searchReset },
                    },
                    [_vm._v("清空")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div"),
      _c(
        "yd-table",
        {
          ref: "advertisingTable",
          attrs: {
            data: _vm.records,
            pagination: _vm.pagination,
            loading: _vm.loading,
          },
          on: { onChange: _vm.onTableChange },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: _vm.activeSource === 4 ? "icon名称" : "广告名称",
              prop: "name",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.openDetail(scope.row)
                          },
                        },
                      },
                      [_vm._v(_vm._s(scope.row.name))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.activeSource === 4 ? "位置" : "广告位置",
              prop: "locationDesc",
              align: "center",
              width: "150",
            },
          }),
          _c("el-table-column", {
            key: "sort",
            attrs: {
              label: _vm.activeSource === 4 ? "排序" : "权重",
              prop: "sort",
              align: "center",
              width: "80",
            },
          }),
          _c("el-table-column", {
            attrs: { label: "图片", prop: "imgUrl", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm.activeSource === 4 || _vm.activeSource === 2
                      ? _c("el-image", {
                          staticStyle: { width: "40px", height: "40px" },
                          attrs: {
                            src: scope.row.imgUrl,
                            "preview-src-list": [scope.row.imgUrl],
                          },
                        })
                      : _c("el-image", {
                          staticStyle: { width: "50px", height: "40px" },
                          attrs: {
                            src: scope.row.imgUrl,
                            "preview-src-list": [scope.row.imgUrl],
                          },
                        }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "展示渠道",
              prop: "displayChannel",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("div", [_vm._v(_vm._s(row.displayChannel || "-"))]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "开始时间", prop: "startTime", align: "center" },
          }),
          _c("el-table-column", {
            attrs: { label: "结束时间", prop: "endTime", align: "center" },
          }),
          _vm.activeSource === 4
            ? _c("el-table-column", {
                attrs: {
                  label: "状态",
                  prop: "statusStr",
                  align: "center",
                  width: "100",
                },
              })
            : _vm._e(),
          _c("el-table-column", {
            attrs: {
              label: "操作",
              prop: "operate",
              align: "center",
              width: "180",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.status > 3
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["user_advertising_data"],
                                expression: "['user_advertising_data']",
                              },
                            ],
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.dataView(scope.row)
                              },
                            },
                          },
                          [_vm._v("数据\n        ")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm.editVisible
        ? _c("advertising-edit", {
            attrs: {
              visible: _vm.editVisible,
              title: _vm.title,
              locationList: _vm.locationList,
              type: _vm.activeSource,
              clientType: _vm.clientType,
              advertisingInfo: _vm.advertisingInfo,
            },
            on: { saveEdit: _vm.saveEdit, closeEdit: _vm.closeEdit },
          })
        : _vm._e(),
      _c("data-view", { ref: "dataView" }),
      _c("advertising-detail", { ref: "advertisingDetail" }),
      _c(
        "YDCommonDialog",
        _vm._b(
          {
            attrs: { show: _vm.dialog.show },
            on: {
              "update:show": function ($event) {
                return _vm.$set(_vm.dialog, "show", $event)
              },
              submit: _vm.dialog.onSubmit,
            },
          },
          "YDCommonDialog",
          _vm.dialog,
          false
        ),
        [
          _vm.dialog.show
            ? _c(
                _vm.dialog.tag,
                _vm._b(
                  {
                    ref: "panel",
                    tag: "component",
                    attrs: { loading: _vm.dialog.loading, title: "" },
                    model: {
                      value: _vm.dialog.modelData,
                      callback: function ($$v) {
                        _vm.$set(_vm.dialog, "modelData", $$v)
                      },
                      expression: "dialog.modelData",
                    },
                  },
                  "component",
                  _vm.dialog,
                  false
                )
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }